const Main = (resolve) => require(["@/components/main/Main.vue"], resolve);
const Main1 = (resolve) => require(["@/components/main/Main1.vue"], resolve);
const shopMain = (resolve) =>
    require(["@/components/main/shopMain.vue"], resolve);

const productMain = (resolve) =>
    require(["@/module/quickorder/productMain.vue"], resolve);

//主页
const Home = (resolve) => require(["@/module/home/Home.vue"], resolve);
const Home1 = (resolve) => require(["@/module/home/Home1.vue"], resolve);
const EditApply = (resolve) =>
    require(["@/module/home/editApply.vue"], resolve);

//消息
const Message = (resolve) =>
    require(["@/module/message/messageList.vue"], resolve);

//分类
const MenuList = (resolve) => require(["@/module/menu/MenuList.vue"], resolve);
//公告管理
const NoticeList = (resolve) =>
    require(["@/module/notice/noticeList.vue"], resolve);
const NoticeView = (resolve) =>
    require(["@/module/notice/noticeView.vue"], resolve);
// 订单收藏
const CollectView = (resolve) =>
    require(["@/module/collect/CollectView.vue"], resolve);
//订单管理
const ShipmentList = (resolve) =>
    require(["@/module/shipment/shipmentList.vue"], resolve);
const ShipmentView = (resolve) =>
    require(["@/module/shipment/shipmentView.vue"], resolve);
const InvoiceList = (resolve) =>
    require(["@/module/invoice/invoiceList.vue"], resolve);
const InvoiceView = (resolve) =>
    require(["@/module/invoice/invoiceView.vue"], resolve);
const BillingList = (resolve) =>
    require(["@/module/billing/billingList.vue"], resolve);
const BillingView = (resolve) =>
    require(["@/module/billing/billingView.vue"], resolve);
const ContractList = (resolve) =>
    require(["@/module/contract/ContractList.vue"], resolve);
const ContractView = (resolve) =>
    require(["@/module/contract/ContractView.vue"], resolve);

const SaleOrderList = (resolve) =>
    require(["@/module/order/saleorderList.vue"], resolve);
const SaleOrderView = (resolve) =>
    require(["@/module/order/saleorderView.vue"], resolve);

const ShoppingMallChooseProduct = (resolve) =>
    require(["@/module/quickorder/chooseProduct.vue"], resolve);
const ShoppingMallSearchProduct = (resolve) =>
    require(["@/module/quickorder/searchProduct.vue"], resolve);
const ProductDetail = (resolve) =>
    require(["@/module/quickorder/productDetail.vue"], resolve);
const OrderConfirm = (resolve) =>
    require(["@/module/quickorder/confirm.vue"], resolve);
const OrderComplete = (resolve) =>
    require(["@/module/quickorder/complete.vue"], resolve);
const ShoppingMallImportProduct = (resolve) =>
    require(["@/module/quickorder/importProduct.vue"], resolve);

const ForecastList = (resolve) =>
    require(["@/module/forecast/forecastList.vue"], resolve);
const ForecastView = (resolve) =>
    require(["@/module/forecast/forecastView.vue"], resolve);
const ForcecastReport = (resolve) =>
    require(["@/module/forecast/forcecastReport.vue"], resolve);

//资料下载
const FileDownloadList = (resolve) =>
    require(["@/module/filedownload/filedownloadList.vue"], resolve);
const FileDownloadView = (resolve) =>
    require(["@/module/filedownload/filedownloadView.vue"], resolve);

//知识库
const knowledgeList = (resolve) =>
    require(["@/module/knowledge/knowledgeList.vue"], resolve);
const knowledgeView = (resolve) =>
    require(["@/module/knowledge/knowledgeView.vue"], resolve);
const knowledgeVideoManual = (resolve) =>
    require(["@/module/knowledge/VideoManual.vue"], resolve);
const knowledgeMaintenancePartView = (resolve) =>
    require(["@/module/knowledge/maintenancePartView.vue"], resolve);
const knowledgeVulnerablePartView = (resolve) =>
    require(["@/module/knowledge/vulnerablePartView.vue"], resolve);

const SalesmanList = (resolve) =>
    require(["@/module/salesman/salesmanList.vue"], resolve);
const SalesmanView = (resolve) =>
    require(["@/module/salesman/salesmanView.vue"], resolve);
const SalesmanEdit = (resolve) =>
    require(["@/module/salesman/salesmanEdit.vue"], resolve);

const CreateOpportunity = (resolve) =>
    require(["@/module/opportunity/createOpportunity.vue"], resolve);
const OpportunityList = (resolve) =>
    require(["@/module/opportunity/opportunityList.vue"], resolve);
const AcceptanceList = (resolve) =>
    require(["@/module/acceptance/acceptanceList.vue"], resolve);
const AcceptanceEdit = (resolve) =>
    require(["@/module/acceptance/acceptanceEdit.vue"], resolve);
const WorkorderList = (resolve) =>
    require(["@/module/srv_workorder/workorderList.vue"], resolve);
const WorkorderEdit = (resolve) =>
    require(["@/module/srv_workorder/workorderEdit.vue"], resolve);
//Warranty Claim
const warrantyClaimList = (resolve) =>
    require(["@/module/warrantyclaim/warrantyClaimList.vue"], resolve);
const warrantyClaimEdit = (resolve) =>
    require(["@/module/warrantyclaim/warrantyClaimEdit.vue"], resolve);

const DealerFeeList = (resolve) =>
    require(["@/module/dealerFee/dealerFeeList.vue"], resolve);
const DealerFeeEdit = (resolve) =>
    require(["@/module/dealerFee/dealerFeeEdit.vue"], resolve);

const MarketMaterialList = (resolve) =>
    require(["@/module/marketMaterial/marketMaterialList.vue"], resolve);
const MarketMaterialEdit = (resolve) =>
    require(["@/module/marketMaterial/marketMaterialEdit.vue"], resolve);

const OpportunityEdit = (resolve) =>
    require(["@/module/opportunity/opportunityEdit.vue"], resolve);

//补件申请
const ResissueApplicationList = (resolve) =>
    require([
        "@/module/resissueapplication/resissueApplicationList.vue",
    ], resolve);
const ResissueApplicationDetail = (resolve) =>
    require([
        "@/module/resissueapplication/resissueApplicationDetail.vue",
    ], resolve);
const QuickOrderList = (resolve) =>
    require(["@/module/quickorder/quickOrderList.vue"], resolve);
const ProPriceList = (resolve) =>
    require(["@/module/proprice/propriceList.vue"], resolve);
const ProPriceView = (resolve) =>
    require(["@/module/proprice/propriceView.vue"], resolve);

//临时额度申请
const TempcreditList = (resolve) =>
    require(["@/module/tempcredit/tempcreditList.vue"], resolve);
const TempcreditView = (resolve) =>
    require(["@/module/tempcredit/tempcreditView.vue"], resolve);

//费用申请
const CostapplyList = (resolve) =>
    require(["@/module/costapply/costapplyList.vue"], resolve);
const CostapplyView = (resolve) =>
    require(["@/module/costapply/costapplyView.vue"], resolve);

//返利管理
const RebatedetailList = (resolve) =>
    require(["@/module/rebatedetail/rebatedetailList.vue"], resolve);

//财务管理   对账单
const AccountStatementList = (resolve) =>
    require(["@/module/accountstatement/accountstatementList.vue"], resolve);

const AccountStatementDetail = (resolve) =>
    require(["@/module/accountstatement/accountstatementDetail.vue"], resolve);
const ResetPasswordView = (resolve) =>
    require(["@/module/resetpassword/ResetPasswordView.vue"], resolve);
const ShoppingCartList = (resolve) =>
    require(["@/module/quickorder/shoppingCartList.vue"], resolve);

//报价单配置
const QuotationConfigList = (resolve) =>
    require(["@/module/quotationconfig/quotationConfigList.vue"], resolve);
const QuotationConfigDetail = (resolve) =>
    require(["@/module/quotationconfig/quotationConfigDetail.vue"], resolve);
const QuoteDetails = (resolve) =>
    require(["@/module/productCatalog/QuoteDetails.vue"], resolve);
const productCatalogIndex = (resolve) =>
    require(["@/module/productCatalog/productCatalogIndex.vue"], resolve);
const collectList = (resolve) =>
    require(["@/module/productCatalog/collectList.vue"], resolve);
const vehicleVarConfigList = (resolve) =>
    require(["@/module/productCatalog/vehicleVarConfigList.vue"], resolve);
const contractConfigList = (resolve) =>
    require(["@/module/productCatalog/ApplicationConfig.vue"], resolve);
//营销物料申请
const applList = (resolve) =>
    require(["@/module/appl/applList.vue"], resolve);
const applEdit = (resolve) =>
    require(["@/module/appl/applEdit.vue"], resolve);

// 经销商首页
const HomePage = (resolve) =>
    require(["@/module/homePage/homePage.vue"], resolve);

// 经销商排名
const DealerRanking = (resolve) =>
    require(["@/module/homePage/dealerRanking.vue"], resolve);

// 公告列表
const AnnouncementList = (resolve) =>
    require(["@/module/homePage/announcementList.vue"], resolve);

// 公告详情
const AnnouncementDetail = (resolve) =>
    require(["@/module/homePage/announcementDetail.vue"], resolve);

// 备件采购列表
const PartsPurchaseOrdersList = (resolve) =>
    require(["@/module/partsPurchaseOrders/partsPurchaseOrdersList.vue"], resolve);

// 备件采购编辑/详情页
const PartsPurchaseOrdersEdit = (resolve) =>
    require(["@/module/partsPurchaseOrders/partsPurchaseOrdersEdit.vue"], resolve);

// 快速创建备件采购
const PartsPurchaseOrdersToOrder = (resolve) =>
    require(["@/module/partsPurchaseOrders/partsPurchaseOrdersDetail.vue"], resolve);

// 备件报价单列表
const partsQuotationList = (resolve) =>
    require(["@/module/partsPurchaseOrders/partsQuotationList.vue"], resolve);

// 备件报价单详情
const partsQuotationEdit = (resolve) =>
    require(["@/module/partsPurchaseOrders/partsQuotationEdit.vue"], resolve);

// 快速添加Gss
const PartsPurchaseOrdersGss = (resolve) =>
    require(["@/module/partsPurchaseOrders/GSS.vue"], resolve);

// 发车单
const DispatchRequestDetail = (resolve) =>
    require(["@/module/partsPurchaseOrders/dispatchRequestDetail.vue"], resolve);

// 备件库存查询
const PartsInventoryCheckList = (resolve) =>
    require(["@/module/partsPurchaseOrders/partsInventoryCheckList.vue"], resolve);
//订单缺货列表
const partsUndeliveredOrdersList= (resolve) =>
    require(["@/module/partsUndeliveredOrders/partsUndeliveredOrderList.vue"], resolve);
//订单缺货详情
const partsUndeliveredOrdersEdit= (resolve) =>
    require(["@/module/partsUndeliveredOrders/partsUndeliveredOrderEdit.vue"], resolve);

// 对账单列表
const StatementList = (resolve) =>
    require(["@/module/statement/statementList.vue"], resolve);

// 对账单详情
const StatementDetail = (resolve) =>
    require(["@/module/statement/statementDetail.vue"], resolve);

// 技术请求单列表
const TechnicalRequestList = (resolve) =>
    require(["@/module/technicalRequest/technicalRequestList.vue"], resolve);

// 技术请求单编辑页/详情页
const TechnicalRequestEdit = (resolve) =>
    require(["@/module/technicalRequest/technicalRequestEdit.vue"], resolve);

// 整机采购列表
const EquipmentPurchaseOrdersList = (resolve) =>
    require(["@/module/equipmentPurchaseOrders/equipmentPurchaseOrdersList.vue"], resolve);

// 整机采购编辑页/详情页
const EquipmentPurchaseOrdersEdit = (resolve) =>
    require(["@/module/equipmentPurchaseOrders/equipmentPurchaseOrdersEdit.vue"], resolve);

// 整机库存查询
const EquipmentInventoryCheckList = (resolve) =>
    require(["@/module/equipmentPurchaseOrders/equipmentInventoryCheckList.vue"], resolve);
//经销商库存报表
const DealerInventoryReport = (resolve) =>
    require(["@/module/equipmentPurchaseOrders/DealerInventoryReport.vue"], resolve);

// 发车申请单（子公司）/详情页
const SubdeliverEdit = (resolve) =>
    require(["@/module/equipmentPurchaseOrders/subdeliverEdit.vue"], resolve);

// 分配单列表
const PayBackList = (resolve) =>
    require(["@/module/payback/paybacklist.vue"], resolve);

// 分配单详情
const PayBackDetail = (resolve) =>
    require(["@/module/payback/paybackdetail.vue"], resolve);

const FeedBackList = (resolve) =>
    require(["@/module/feedback/feedbacklist.vue"], resolve);

const FeedBackDetail = (resolve) =>
    require(["@/module/feedback/feedbackdetail.vue"], resolve);
//服务站档案
const ServiceStationList = (resolve) =>
    require(["@/module/archive/ServiceStationList.vue"], resolve);
const ServiceStationDetail = (resolve) =>
    require(["@/module/archive/ServiceStationDetail.vue"], resolve);
//服务人员档案
const ServiceWorkList = (resolve) =>
    require(["@/module/archive/ServiceWorkList.vue"], resolve);
const ServiceWorkDetail = (resolve) =>
    require(["@/module/archive/ServiceWorkDetail.vue"], resolve);
//产品档案
const ProductList = (resolve) =>
    require(["@/module/archive/ProductList.vue"], resolve);
const ProductFilesDetail = (resolve) =>
    require(["@/module/archive/ProductFilesDetail.vue"], resolve);
//产品档案
const WorkLogList = (resolve) =>
    require(["@/module/archive/WorkLogList.vue"], resolve);
const WorkLogDetail = (resolve) =>
    require(["@/module/archive/WorkLogDetail.vue"], resolve);
//服务车
const ServiceCarList = (resolve) =>
    require(["@/module/archive/ServiceCarList.vue"], resolve);
const ServiceCarDetail = (resolve) =>
    require(["@/module/archive/ServiceCarDetail.vue"], resolve);
//回访单
const SurveyList = (resolve) =>
    require(["@/module/archive/SurveyList.vue"], resolve);
const SurveyDetail = (resolve) =>
    require(["@/module/archive/SurveyDetail.vue"], resolve);
//质保申请单
const PartsapplyList = (resolve) =>
    require(["@/module/archive/PartsapplyList.vue"], resolve);
const PartsapplyDetail = (resolve) =>
    require(["@/module/archive/PartsapplyDetail.vue"], resolve);
//整机采购报表
const SubDeliverReport = (resolve) =>
    require(["@/module/report/subDeliverReport.vue"], resolve);
//备件采购报表
const PartDeliverReport = (resolve) =>
    require(["@/module/report/partDepartureReport.vue"], resolve);
//Service Fee Settlement
const feeSettlementList = (resolve) =>
    require(["@/module/feesettlement/feeSettlementList.vue"], resolve);
const feeSettlementEdit = (resolve) =>
    require(["@/module/feesettlement/feeSettlementEdit.vue"], resolve);

//scp嵌入页面
const Scp = (resolve) =>
	require(["@/module/scp/scp.vue"], resolve);

//商机管理
const OpportunityManagementList = (resolve) =>
    require(["@/module/OpportunityManagement/OpportunityManagementList.vue"], resolve);
const OpportunityManagementDetail = (resolve) =>
    require(["@/module/OpportunityManagement/OpportunityManagementDetail.vue"], resolve);
export default [
    {
        path: "/",
        component: Home,
        children: [
            {
                path: "/",
                name: "home",
                meta: {
                    keepAlive: true,
                    allowAnonymous: true,
                },
                component: Home,
            },
        ],
    },
    {
        path: "/home1",
        component: getViews("Main"),
        children: [
            {
                path: "/home1",
                name: "home1",
                component: Home1,
            },
        ],
    },
    {
        path: "/homePage",
        component: getViews("Main"),
        children: [
            {
                path: "/homePage",
                name: "homePage",
                component: HomePage,
            },
        ],
    },
    {
        path: "/homePage",
        component: getViews("Main"),
        children: [
            {
                path: "dealerRanking",
                name: "dealerRanking",
                component: DealerRanking,
            },
        ],
    },
    {
        path: "/homePage",
        component: getViews("Main"),
        children: [
            {
                path: "announcementList",
                name: "announcementList",
                component: AnnouncementList,
            },
        ],
    },
    {
        path: "/homePage",
        component: getViews("Main"),
        children: [
            {
                path: "announcementDetail",
                name: "announcementDetail",
                component: AnnouncementDetail,
            },
        ],
    },
    {
        path: "/edit",
        component: getViews("Main"),
        children: [
            {
                path: "apply",
                name: "editApply",
                component: EditApply,
            },
        ],
    },
    {
        path: "/message",
        component: getViews("Main"),
        children: [
            {
                path: "message",
                name: "message",
                meta: {
                    keepAlive: true,
                },
                component: Message,
            },
        ],
    },
    {
        path: "/menu",
        component: getProductViews("productMain"),
        children: [
            {
                path: "menulist",
                name: "menu-list",
                meta: {
                    allowAnonymous: true,
                },
                component: MenuList,
            },
        ],
    },
    {
        path: "/notice",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "NoticeList",
                component: NoticeList,
            },
            {
                path: "view/:id",
                name: "notice-detail",
                component: NoticeView,
            },
        ],
    },
    {
        path: "/shoppingmall",
        component: getProductViews("productMain"),
        children: [
            {
                path: "chooseproduct/:name?/:id?",
                name: "ShoppingMallChooseProduct",
                meta: {
                    allowAnonymous: true,
                    keepAlive: true,
                },
                component: ShoppingMallChooseProduct,
            },
            {
                path: "searchproduct/:name?",
                name: "ShoppingMallSearchProduct",
                meta: {
                    allowAnonymous: true,
                },
                component: ShoppingMallSearchProduct,
            },
            {
                path: "productdetail",
                name: "product-detail",
                meta: {
                    allowAnonymous: true,
                },
                component: ProductDetail,
            },
        ],
    },
    {
        path: "/collect",
        component: getViews("Main"),
        children: [
            {
                path: "view",
                name: "collect-view",
                component: CollectView,
            },
        ],
    },

    {
        path: "/shipment",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "ShipmentList",
                component: ShipmentList,
            },
            {
                path: "view/:id",
                name: "ShipmentView",
                component: ShipmentView,
            },
        ],
    },
    {
        path: "/invoice",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "InvoiceList",
                component: InvoiceList,
            },
            {
                path: "view/:id",
                name: "InvoiceView",
                component: InvoiceView,
            },
        ],
    },
    {
        path: "/billing",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "BillingList",
                component: BillingList,
            },
            {
                path: "view/:id",
                name: "BillingView",
                component: BillingView,
            },
        ],
    },
    {
        path: "/order",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "SaleOrderList",
                component: SaleOrderList,
            },
            {
                path: ":id/:name/:time/complete",
                name: "OrderComplete",
                component: OrderComplete,
            },
            {
                path: ":id/detail",
                name: "order-detail",
                component: SaleOrderView,
            },
        ],
    },
    {
        path: "/shopcart",
        component: getViews("shopMain"),
        children: [
            {
                path: "list",
                name: "ShoppingCartList",
                component: ShoppingCartList,
            },
        ],
    },
    {
        path: "/confirm",
        component: getProductViews("OrderConfirm"),
        children: [
            {
                path: ":id/order",
                name: "OrderConfirm",
                component: OrderConfirm,
            },
        ],
    },
    {
        path: "/quickorder",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "QuickOrderList",
                component: QuickOrderList,
            },
            ,
            {
                path: "importproduct",
                meta: {
                    keepAlive: true,
                    allowAnonymous: true,
                },
                component: ShoppingMallImportProduct,
            },
        ],
    },
    {
        path: "/contract",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "ContractList",
                component: ContractList,
            },
            {
                path: "view/:id",
                name: "ContractView",
                component: ContractView,
            },
        ],
    },
    {
        path: "/proprice",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "ProPriceList",
                component: ProPriceList,
            },
            {
                path: "create",
                name: "ProPriceCreate",
                component: ProPriceView,
            },
            {
                path: "view/:id",
                name: "proprice-detail",
                component: ProPriceView,
            },
        ],
    },
    {
        path: "/salesforecast",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "ForecastList",
                component: ForecastList,
            },
            {
                path: "view/:id",
                name: "ForecastView",
                component: ForecastView,
            },
            {
                path: "create",
                name: "ForecastCreate",
                component: ForecastView,
            },
            {
                path: "report",
                name: "ForcecastReport",
                component: ForcecastReport,
            },
        ],
    },
    {
        path: "/filedownload",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "FileDownloadList",
                component: FileDownloadList,
            },
            {
                path: "view/:id",
                name: "FileDownloadView",
                component: FileDownloadView,
            },
        ],
    },
    {
        path: "/knowledge",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "knowledgeList",
                component: knowledgeList,
            },
            {
                path: "view/:id",
                name: "knowledgeView",
                component: knowledgeView,
            },
            {
                path: "VideoManual",
                name: "knowledgeVideoManual",
                component: knowledgeVideoManual,
            },
            {
                path: "maintenancePartView",
                name: "knowledgeMaintenancePartView",
                component: knowledgeMaintenancePartView,
            },
            {
                path: "vulnerablePartView",
                name: "knowledgeVulnerablePartView",
                component: knowledgeVulnerablePartView,
            },
        ],
    },
    {
        path: "/salesman",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "SalesmanList",
                component: SalesmanList,
            },
            {
                path: "Edit/:id",
                name: "SalesmanEdit",
                component: SalesmanEdit,
            },
            {
                path: "view",
                name: "SalesmanView",
                component: SalesmanView,
            },
        ],
    },
    {
        path: "/opportunity",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "OpportunityList",
                component: OpportunityList,
            },
            {
                path: "edit/:id",
                name: "OpportunityEdit",
                component: OpportunityEdit,
            },
            {
                path: "create",
                name: "CreateOpportunity",
                component: CreateOpportunity,
            },
        ],
    },
    {
        path: "/acceptance",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "AcceptanceList",
                component: AcceptanceList,
            },
            {
                path: "edit",
                name: "AcceptanceEdit",
                component: AcceptanceEdit,
            },
        ],
    },
    {
        path: "/workorderList",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "workorderList",
                component: WorkorderList,
            },
            {
                path: "edit",
                name: "workorderEdit",
                component: WorkorderEdit,
            },
        ],
    },
    {
        path: "/dealerFee",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "DealerFeeList",
                component: DealerFeeList,
            },
            {
                path: "edit",
                name: "DealerFeeEdit",
                component: DealerFeeEdit,
            },
        ],
    },
    {
        path: "/warrantyClaim",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "warrantyClaimList",
                component: warrantyClaimList,
            },
            {
                path: "edit",
                name: "warrantyClaimEdit",
                component: warrantyClaimEdit,
            },
        ],
    },
    {
        path: "/marketMaterial",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "MarketMaterialList",
                component: MarketMaterialList,
            },
            {
                path: "edit",
                name: "MarketMaterialEdit",
                component: MarketMaterialEdit,
            },
        ],
    },
    {
        path: "/resissueapplication",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "ResissueApplicationList",
                component: ResissueApplicationList,
            },
            {
                path: "detail/:id",
                name: "ResissueApplicationDetail",
                component: ResissueApplicationDetail,
            },
        ],
    },
    {
        path: "/tempcredit",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "TempcreditList",
                component: TempcreditList,
            },
            {
                path: "view/:id",
                name: "tempcredit-detail",
                component: TempcreditView,
            },
            {
                path: "create",
                name: "TempcreditCreate",
                component: TempcreditView,
            },
        ],
    },
    {
        path: "/costapply",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "CostapplyList",
                component: CostapplyList,
            },
            {
                path: "view/:id",
                name: "costapply-detail",
                component: CostapplyView,
            },
            {
                path: "create",
                name: "CostapplyCreate",
                component: CostapplyView,
            },
        ],
    },
    {
        path: "/rebatedetail",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "RebatedetailList",
                component: RebatedetailList,
            },
        ],
    },
    {
        path: "/accountstatementlist",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "accountstatementList",
                component: AccountStatementList,
            },
        ],
    },
    {
        path: "/accountstatementDetail/:id/:date",
        component: getViews("Main"),
        children: [
            {
                path: "detail",
                name: "accountstatement-detail",
                component: AccountStatementDetail,
            },
        ],
    },
    {
        path: "/resetpassword",
        component: getViews("Main"),
        children: [
            {
                path: "view",
                name: "resetpassword-view",
                component: ResetPasswordView,
            },
        ],
    },
    //配置报价
    {
        path: "/quotationconfig/list",
        name: "quotationconfiglist",
        meta: {
            allowAnonymous: true,
        },
        component: QuotationConfigList,
    },
    {
        path: "/quotationconfig/create/:quoteId?",
        name: "quotationconfigcreate",
        meta: {
            allowAnonymous: true,
        },
        component: QuotationConfigDetail,
    },
    {
        path: "/quotationconfig/edit/:quoteId?/:cpqQuoteId?",
        name: "quotationconfigedit",
        meta: {
            allowAnonymous: true,
        },
        component: QuotationConfigDetail,
    },
    {
        path: "/quote/details/:cpqQuoteId?",
        name: "quotedetails",
        meta: {
            allowAnonymous: true,
        },
        component: QuoteDetails,
    },
    {
        path: "/product/catalog",
        name: "productcatalog",
        meta: {
            allowAnonymous: true,
        },
        component: productCatalogIndex,
    },
    {
        path: "/collect/list",
        name: "collectlist",
        meta: {
            allowAnonymous: true,
        },
        component: collectList,
    },
    {
        path: "/config/page",
        name: "configpage",
        meta: {
            allowAnonymous: true,
        },
        component: vehicleVarConfigList,
    },
    {
        path: "/config/linepage",
        name: "configlinepage",
        meta: {
            allowAnonymous: true,
        },
        component: contractConfigList,
    },
    {
        path: "/appl",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "appl-list",
                component: applList
            },
            {
                path: "edit/:id",
                name: "appl-edit",
                component: applEdit
            },
        ],
    },
    {
        path: "/appl",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "appl-list",
                component: applList
            },
            {
                path: "edit/:id",
                name: "appl-edit",
                component: applEdit
            },
        ],
    },
    {
        path: "/partsPurchaseOrders",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "partsPurchaseOrders-list",
                component: PartsPurchaseOrdersList
            },
            {
                path: "edit",
                name: "partsPurchaseOrders-edit",
                component: PartsPurchaseOrdersEdit
            },
            {
                path: "toOrder",
                name: "partsPurchaseOrders-toOrder",
                component: PartsPurchaseOrdersToOrder
            },
            {
                path: "Gss",
                name: "partsPurchaseOrders-gss",
                component: PartsPurchaseOrdersGss
            },
            {
                path: "QuotationList",
                name: "partsPurchaseOrders-QuotationList",
                component: partsQuotationList
            },
            {
                path: "partsQuotationEdit",
                name: "partsPurchaseOrders-QuotationEdit",
                component: partsQuotationEdit
            }
        ],
    },
    {
        path: "/partsUndeliveredOrders",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "partsUndeliveredOrders-list",
                component: partsUndeliveredOrdersList
            },
            {
                path: "edit",
                name: "partsUndeliveredOrders-edit",
                component: partsUndeliveredOrdersEdit
            },
            // {
            //     path: "toOrder",
            //     name: "partsPurchaseOrders-toOrder",
            //     component: PartsPurchaseOrdersToOrder
            // },
            // {
            //     path: "Gss",
            //     name: "partsPurchaseOrders-gss",
            //     component: PartsPurchaseOrdersGss
            // },
        ],
    },
    {
        path: "/dispatchRequest",
        component: getViews("Main"),
        children: [
            {
                path: "detail",
                name: "dispatchRequest-detail",
                component: DispatchRequestDetail
            },
        ],
    },
    {
        path: "/partsInventoryCheck",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "partsInventoryCheck-list",
                component: PartsInventoryCheckList
            },
        ],
    },
    {
        path: "/statement",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "statement-list",
                component: StatementList
            },
            {
                path: "detail",
                name: "statement-detail",
                component: StatementDetail
            },
        ],
    },
    {
        path: "/technicalRequest",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "technicalRequest-list",
                component: TechnicalRequestList
            },
            {
                path: "edit",
                name: "technicalRequest-edit",
                component: TechnicalRequestEdit
            },
        ],
    },
    {
        path: "/equipmentPurchaseOrders",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "equipmentPurchaseOrders-list",
                component: EquipmentPurchaseOrdersList
            },
            {
                path: "edit",
                name: "equipmentPurchaseOrders-edit",
                component: EquipmentPurchaseOrdersEdit
            },
        ],
    },
    {
        path: "/equipmentInventoryCheck",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "equipmentInventoryCheck-list",
                component: EquipmentInventoryCheckList
            },
        ],
    }, 
    {
        path: "/DealerInventoryReport",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "DealerInventoryReport-list",
                component: DealerInventoryReport
            },
        ],
    }, 
    {
        path: "/subdeliverEdit",
        component: getViews("Main"),
        children: [
            {
                path: "edit",
                name: "subdeliver-edit",
                component: SubdeliverEdit
            },
        ],
    },
    {
        path: "/payback",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "payback-list",
                component: PayBackList
            },
            {
                path: "detail",
                name: "payback-detail",
                component: PayBackDetail
            }
        ],
    },
    {
        path: "/feedback",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "feedback-list",
                component: FeedBackList
            },
            {
                path: "detail",
                name: "feedback-detail",
                component: FeedBackDetail
            }
        ],
    },
    {
        path: "/archive",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "ServiceStation-list",
                component: ServiceStationList
            },
            {
                path: "detail",
                name: "ServiceStation-detail",
                component: ServiceStationDetail
            }
        ],
    },
    {
        path: "/archive",
        component: getViews("Main"),
        children: [
            {
                path: "Servicelist",
                name: "ServiceWork-list",
                component: ServiceWorkList
            },
            {
                path: "Servicedetail",
                name: "ServiceWork-detail",
                component: ServiceWorkDetail
            }
        ],
    },
    {
        path: "/archive",
        component: getViews("Main"),
        children: [
            {
                path: "Productlist",
                name: "Product-list",
                component: ProductList
            },
            {
                path: "Productdetail",
                name: "ProductFiles-detail",
                component: ProductFilesDetail
            }
        ],
    },
    {
        path: "/archive",
        component: getViews("Main"),
        children: [
            {
                path: "WorkLoglist",
                name: "WorkLog-list",
                component: WorkLogList
            },
            {
                path: "WorkLogdetail",
                name: "WorkLog-detail",
                component: WorkLogDetail
            }
        ],
    },
    {
        path: "/archive",
        component: getViews("Main"),
        children: [
            {
                path: "ServiceCarList",
                name: "ServiceCar-list",
                component: ServiceCarList
            },
            {
                path: "ServiceCarDetail",
                name: "ServiceCar-detail",
                component: ServiceCarDetail
            }
        ],
    },
    {
        path: "/archive",
        component: getViews("Main"),
        children: [
            {
                path: "Surveylist",
                name: "Survey-list",
                component: SurveyList
            },
            {
                path: "Surveydetail",
                name: "Survey-detail",
                component: SurveyDetail
            }
        ],
    },
    {
        path: "/archive",
        component: getViews("Main"),
        children: [
            {
                path: "Partsapplylist",
                name: "Partsapply-list",
                component: PartsapplyList
            },
            {
                path: "Partsapplydetail",
                name: "Partsapply-detail",
                component: PartsapplyDetail
            }
        ],
    },
    // 新增整机采购报表子路由
    {
        path: "/report",
        component: getViews("Main"),
        children: [
            {
                path: "subDeliverReport",
                name: "SubDeliverReport",
                component: SubDeliverReport
            },
            {
                path: "partDeliverReport",
                name: "PartDeliverReport",
                component: PartDeliverReport
            }
        ],
    },
     {
        path: "/feeSettlement",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "feeSettlementList",
                component: feeSettlementList,
            },
            {
                path: "edit",
                name: "feeSettlementEdit",
                component: feeSettlementEdit,
            },
        ],
    },

	 // 新增SCP嵌入路由
	    {
	        path: "/report",
	        component: getViews("Main"),
	        children: [
	            {
	                path: "scp",
	                name: "scp",
	                component: Scp
	            }
	        ],
	    },
    {
        path: "/OpportunityManagement",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "opportunityManagementList",
                component: OpportunityManagementList
            },
             {
                path: "detail",
                name: "opportunityManagementDetail",
                component: OpportunityManagementDetail
            }
        ],
    }
];
import store from "../store";

function getViews(path) {
    const isStore = store.state.isStore;
    if (isStore) {
        return (resolve) =>
            require(["@/components/main/" + path + ".vue"], resolve);
    } else {
        return (resolve) => require(["@/components/main/Main1.vue"], resolve);
    }
}

function getProductViews(path) {
    const isStore = store.state.isStore;
    if (isStore) {
        return (resolve) =>
            require(["@/module/quickorder/" + path + ".vue"], resolve);
    } else {
        return (resolve) => require(["@/components/main/Main1.vue"], resolve);
    }
}



// WEBPACK FOOTER //
// ./src/module/router.js